import { render, staticRenderFns } from "./BlockDetail.pc.vue?vue&type=template&id=727f45d9&scoped=true&"
import script from "./BlockDetail.pc.vue?vue&type=script&lang=js&"
export * from "./BlockDetail.pc.vue?vue&type=script&lang=js&"
import style0 from "./BlockDetail.pc.vue?vue&type=style&index=0&id=727f45d9&lang=scss&scoped=true&"
import style1 from "./BlockDetail.pc.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727f45d9",
  null
  
)

export default component.exports